import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const eldmandateprimeConfig: TSPConfig = {
  key: 'eldmandateprime',
  name: 'ELD Mandate Prime',
  imageName: 'ELDMandatePrime',
  category: TSPCategory.API_KEY,
  helpText:
    'Please request a HOSClientApiKey from your ELD Mandate Prime representative.',
  loginComponent: (props) => (
    <LoginCreds
      fields={[{ name: 'apikey', label: 'HOSClientApiKey' }]}
      onValidityChange={props.onValidityChange}
    />
  ),
};

export default eldmandateprimeConfig;
